import { TeeImagePopupComponent } from './tee-image-popup';
export const TeeImagePopup = TeeImagePopupComponent;